<template>
  <div>
    <v-card class="mx-3 mb-3">

      <v-card-title>
        <!--                <v-icon class="mr-3">mdi-medal</v-icon>-->
        Medaillen
        <v-spacer/>
        <v-btn text fab small @click="onHelpWochengesamtwertung">
          <v-icon>mdi-help-circle-outline</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
                <span v-if="!loading && numMedals <= 0">
                  Du hast noch keine Medaillen. Erreiche jede Woche deine Ziele um Medaillen zu gewinnen.
                </span>
        <div v-else-if="loading">
          <v-progress-linear indeterminate></v-progress-linear>
        </div>
        <div v-else>
          <div class="body-1 d-flex justify-space-between">
            <div>
              <span>Mein Leben</span><br/>
              <span class="body-2">({{ numWeeks }} Wochen)</span>
            </div>
            <span v-if="isFree">
              Zeitraum: Gesamt
            </span>
            <v-select v-else v-model="epoch" :items="epochs" class="mt-n4" style="max-width: 50%;"/>
          </div>
          <v-row class="px-3 mt-2 d-flex justify-space-between">
            <div v-for="item in numbers('index')" class="pr-2" :style="`opacity:${item.num==0 ? 0.4 : 1}`">
              <medal :type="item.value" style="height:40px;"></medal>
              <span class="display-1">{{ item.num }}</span>
            </div>
          </v-row>
          <div class="mt-3">
            <p>
              Wohlbefinden
            </p>
            <v-row class="px-3 d-flex justify-space-between">
              <div v-for="item in numbers('happyness')" class="pr-2" :style="`opacity:${item.num==0 ? 0.4 : 1}`">
                <!--              <medal :type="item.value" style="height:30px;"></medal>-->
                <v-icon size="30" class="mt-n3 ml-2 mr-2">{{ wohlbefindenIcon(item.value) }}</v-icon>
                <span class="display-1">{{ item.num }}</span>
              </div>
            </v-row>
          </div>
          <v-divider class="mt-3"></v-divider>
          <div v-for="b in bereiche" class="mt-3">
            <p>
              {{ b.name }}
            </p>
            <v-row class="px-3 d-flex justify-space-between">
              <div v-for="item in numbers(b.bid)" class="pr-2" :style="`opacity:${item.num==0 ? 0.4 : 1}`">
                <medal :type="item.value" style="height:30px;"></medal>
                <span class="display-1">{{ item.num }}</span>
              </div>
            </v-row>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <div v-if="(isFree)" class="text-xl-center mb-3 ml-3 mr-1">
      <div class="mt-3 pa-3"
           style="border: 1px dashed dodgerblue; width: calc( 100% - 8px); height: 240px; border-radius: 5px; background-color: #ffffff30">
        <span class="headline">Verschiedene Zeiträume?</span>
        <br/><br/>
        Mit aimz <pro/> kannst du dir ansehen, welche Medaillen du im letzten Monat, Quartal, Haljahr oder Jahr gesammelt hast.
        <br/><br/>
        <v-btn rounded class="d-flex mx-10 gelb dunkelblau--text" href="https://www.digistore24.com/product/410225"
               target="_blank">Upgrade auf aimz PRO</v-btn>
      </div>
    </div>

    <div class="d-flex">
      <v-btn class="mx-auto mt-3 mb-3" href="https://youtu.be/r_F-XD0UISo" target="_blank">
        <v-icon class="mr-2">mdi-play-box-outline</v-icon>
        Videoanleitung
      </v-btn>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import UserData from "@/views/UserData";
import CenterContainer from "@/components/CenterContainer";
import Activities from "@/components/Activities";
import InitializeUser from "@/views/InitializeUser";
import Dashboard from "@/components/Dashboard";
import UserLib from "@/components/UserLib";
import Header1 from "@/components/Header1";
import Kinds from "@/components/Kinds";
import Medal from "@/components/Medal";
import Pro from "@/components/Pro";


const {DateTime} = require("luxon");

const ALL = "Gesamt";
const THIS_YEAR = "Dieses Jahr";
const LAST_YEAR = "Letztes Jahr";
const THIS_QUARTER = "Dieses Quartal";
const LAST_QUARTER = "Letztes Quartal";
const THIS_MONTH = "Dieses Monat";
const LAST_MONTH = "Letztes Monat";

export default {
  name: 'Medaillen',
  components: {Medal, CenterContainer, Header1, Pro},
  data: () => ({
    medals: [],
    loading: false,
    epochs: [ALL, THIS_YEAR, LAST_YEAR, THIS_QUARTER, LAST_QUARTER, THIS_MONTH, LAST_MONTH],
    epoch: ALL,
    indices: [],
  }),
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      //var id = Badge.makeId(this.weekDate.toISODate(), "index");
      var badges = (await this.$backend.get_all_objects(Kinds.KIND_BADGE)) || [];
      console.log("Badges: ", badges);
      this.medals = badges;
      this.indices = (await this.$backend.get_all_objects(Kinds.KIND_INDEX)) || [];
      this.loading = false;
    },
    wohlbefindenIcon(value) {
      if (value === "gold")
        return 'mdi-emoticon-happy-outline';
      if (value === "silver")
        return 'mdi-emoticon-neutral-outline';
      if (value === "bronze")
        return 'mdi-emoticon-sad-outline';
      return 'mdi-emoticon-neutral-outline';
    },
    medalsOfEpoch() {
      var date = DateTime.local();
      var year = date.toISODate().substring(0, 4);
      var lastYear = date.minus({years: 1}).toISODate().substring(0, 4);
      switch (this.epoch) {
        case THIS_YEAR:
          return this.medals.filter(x => x.date.startsWith(year));
        case LAST_YEAR:
          return this.medals.filter(x => x.date.startsWith(lastYear));
        case THIS_QUARTER:
          var month = new Date(Date.now()).getMonth();
          var q = Math.floor(month / 3) + 1;
          console.log("filtering THIS_QUARTER " + q);
          switch (q) {
            case 1:
              return this.medals.filter(x => x.date.startsWith(year + "-01") || x.date.startsWith(year + "-02") || x.date.startsWith(year + "-03"));
            case 2:
              return this.medals.filter(x => x.date.startsWith(year + "-04") || x.date.startsWith(year + "-05") || x.date.startsWith(year + "-06"));
            case 3:
              return this.medals.filter(x => x.date.startsWith(year + "-07") || x.date.startsWith(year + "-08") || x.date.startsWith(year + "-09"));
            case 4:
              return this.medals.filter(x => x.date.startsWith(year + "-10") || x.date.startsWith(year + "-11") || x.date.startsWith(year + "-12"));
          }
          break;
        case LAST_QUARTER:
          var month = new Date(Date.now()).getMonth();
          var q = Math.floor(month / 3) + 0; // <-- last quarter!
          console.log("filtering LAST_QUARTER " + q);
          switch (q) {
            case 0:
              return this.medals.filter(x => x.date.startsWith(lastYear + "-10") || x.date.startsWith(lastYear + "-11") || x.date.startsWith(lastYear + "-12"));
            case 1:
              return this.medals.filter(x => x.date.startsWith(year + "-01") || x.date.startsWith(year + "-02") || x.date.startsWith(year + "-03"));
            case 2:
              return this.medals.filter(x => x.date.startsWith(year + "-04") || x.date.startsWith(year + "-05") || x.date.startsWith(year + "-06"));
            case 3:
              return this.medals.filter(x => x.date.startsWith(year + "-07") || x.date.startsWith(year + "-08") || x.date.startsWith(year + "-09"));
          }
          break;
        case THIS_MONTH:
          var mon = date.toISODate().substring(0, 7);
          console.log("filtering THIS_MONTH " + mon);
          return this.medals.filter(x => x.date.startsWith(mon));
        case LAST_MONTH:
          var mon = date.minus({months: 1}).toISODate().substring(0, 7);
          console.log("filtering LAST_MONTH " + mon);
          return this.medals.filter(x => x.date.startsWith(mon));
      }
      return this.medals;
    },
    indicesOfEpoch() {
      var date = DateTime.local();
      var year = date.toISODate().substring(0, 4);
      var lastYear = date.minus({years: 1}).toISODate().substring(0, 4);
      switch (this.epoch) {
        case THIS_YEAR:
          return this.indices.filter(x => x.date.startsWith(year));
        case LAST_YEAR:
          return this.indices.filter(x => x.date.startsWith(lastYear));
        case THIS_QUARTER:
          var month = new Date(Date.now()).getMonth();
          var q = Math.floor(month / 3) + 1;
          console.log("filtering THIS_QUARTER " + q);
          switch (q) {
            case 1:
              return this.indices.filter(x => x.date.startsWith(year + "-01") || x.date.startsWith(year + "-02") || x.date.startsWith(year + "-03"));
            case 2:
              return this.indices.filter(x => x.date.startsWith(year + "-04") || x.date.startsWith(year + "-05") || x.date.startsWith(year + "-06"));
            case 3:
              return this.indices.filter(x => x.date.startsWith(year + "-07") || x.date.startsWith(year + "-08") || x.date.startsWith(year + "-09"));
            case 4:
              return this.indices.filter(x => x.date.startsWith(year + "-10") || x.date.startsWith(year + "-11") || x.date.startsWith(year + "-12"));
          }
          break;
        case LAST_QUARTER:
          var month = new Date(Date.now()).getMonth();
          var q = Math.floor(month / 3) + 0; // <-- last quarter!
          console.log("filtering LAST_QUARTER " + q);
          switch (q) {
            case 0:
              return this.indices.filter(x => x.date.startsWith(lastYear + "-10") || x.date.startsWith(lastYear + "-11") || x.date.startsWith(lastYear + "-12"));
            case 1:
              return this.indices.filter(x => x.date.startsWith(year + "-01") || x.date.startsWith(year + "-02") || x.date.startsWith(year + "-03"));
            case 2:
              return this.indices.filter(x => x.date.startsWith(year + "-04") || x.date.startsWith(year + "-05") || x.date.startsWith(year + "-06"));
            case 3:
              return this.indices.filter(x => x.date.startsWith(year + "-07") || x.date.startsWith(year + "-08") || x.date.startsWith(year + "-09"));
          }
          break;
        case THIS_MONTH:
          var mon = date.toISODate().substring(0, 7);
          console.log("filtering THIS_MONTH " + mon);
          return this.indices.filter(x => x.date.startsWith(mon));
        case LAST_MONTH:
          var mon = date.minus({months: 1}).toISODate().substring(0, 7);
          console.log("filtering LAST_MONTH " + mon);
          return this.indices.filter(x => x.date.startsWith(mon));
      }
      return this.indices;
    },
    numbers(type) {
      var medalsOfType = [...this.medalsOfEpoch().filter(x => x.type === type)];
      return [
        // note: diamond is for backwards compatibility, the back-end granted diamonds until 2021-08-11 !!
        {value: 'gold', num: medalsOfType.filter(x => x.value === 'gold' || x.value === 'diamond').length},
        {value: 'silver', num: medalsOfType.filter(x => x.value === 'silver').length},
        {value: 'bronze', num: medalsOfType.filter(x => x.value === 'bronze').length},
      ];
    },
    onHelpWochengesamtwertung() {
      this.$events.$emit("ask", {
        title: 'Medaillen', yes_button: 'OK',
        question: 'Medaillen kannst du jede Woche gewinnen, wenn du deine Ziele erreichst. Für 75% gibt es Bronze, für 90% Silber und ab 100% Gold.<br>' +
            'Sie sollen dich anspornen die gesteckten Ziele auch wirklich zu erreichen<br><br>' +
            'Die großen Medaillen werden nach dem Wochenindex vergeben, die kleinen nach dem Bereichsindex. Da der Wochenindex aus den gewichteten Bereichsindizes gemittelt wird, ' +
            'ist die Anzahl der großen Medaillen immer weniger als die Summe der Bereichsmedaillen.',
      });
    },
  },
  computed: {
    isFree() {
      return this.$app.isFree;
    },
    isSilver() {
      return this.$app.isSilver;
    },
    isGold() {
      return this.$app.isGold;
    },
    app() {
      return this.$app;
    },
    numMedals() {
      return this.medals.length;
    },
    indexMedals() {
      return this.medals.filter(x => x.type === 'index');
    },
    bereiche() {
      return this.$app.bereiche;
    },
    numWeeks() {
      return this.indicesOfEpoch().length;
    }
  },
  watch: {
    // is_logged_in(n, o) {
    //     console.log("is_logged_in: " + n);
    //     if (!n) {
    //         this.$router.go(-1000);
    //         this.$router.replace("/")
    //     }
    // }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>